<template lang="pug">
  div(class="container")
    GmapMap(v-if="loaded" :center='{lat:38.878337, lng:-77.100703}', :zoom='zoom', :map-type-id='maptype', :style="{width: '100%', height: height}" )
      GmapInfoWindow(v-if="currentMarker" :options='infoOptions' :position='infoWindowPos' :opened='infoWinOpen' @closeclick='infoWinOpen=false')
        h3 {{currentMarker.Name}}
        //- span(v-if='currentMarker.Image')
        //-   img(:src='currentMarker.Image')
        //-   br
        span 
          strong Address: 
          | {{currentMarker.Address}} {{currentMarker.City}}, {{currentMarker.State}} {{currentMarker.Zipcode}}
        br
        span 
          strong Day of Week: 
          | {{currentMarker['Day of Week']}}
        br
        span 
          strong URL: 
          a(:href='currentMarker.URL', target="_blank") {{currentMarker.URL}}
      GmapMarker(:key='index', v-for='(m, index) in markers', :position='m.position', :clickable='true', @click='toggleInfoWindow(m,index)')
    div(class="text-center" v-if="!loaded").mt-12
      v-progress-circular(indeterminate class="mb-2" :size="50" :width="5" color="primary")
    
</template>
 
<script>
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyD2ZiMwJo3y5QKPWnXWS_wwdtDM6ACLJPY",
    libraries: ["visualization"]
  },
  installComponents: true
});

export default {
  name: "FarmersMarketMap",
  props: {
    width: Number,
    height: String,
    maptype: String,
    zoom: Number
  },
  data() {
    return {
      loaded: false,
      markers: [],
      currentMarker: null,
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    };
  },
  mounted() {
    this.buildData();
  },
  computed: { google: VueGoogleMaps.gmapApi },
  methods: {
    buildData() {
      this.getData()
        .then(this.groupData)
        .then(this.plotData);
    },
    getData() {
      return new Promise(resolve => {
        fetch(
          `https://download.data.arlingtonva.us/Uploads/AutomatedJobs/Farmers+market.json`
        ).then(response => {
          resolve(response.json());
        });
      });
    },
    groupData(data) {
      return new Promise(resolve => {
        var pdata = data.map(d => ({
          ...d,
          position: { lat: d.Latitude, lng: d.Longitude }
        }));
        resolve(pdata);
      });
    },
    plotData(data) {
      this.markers = data;
      this.loaded = true;
    },
    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.Name;
      this.currentMarker = marker;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
};
</script>